export default function Incinerator() {
  return (
    <div className="min-h-screen relative z-10">
      {/* Hero Section */}
      <section className="py-20 px-4 text-center">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <img 
              src="https://static.lumi.new/b9/b9ad0ecc8747d33c4480f6df3a23299e.webp" 
              alt="Incinerator Logo" 
              className="w-full max-w-2xl mx-auto h-auto"
            />
          </div>

          {/* Visit Website Button */}
          <div className="mb-12">
            <a 
              href="https://burn.MandoxToken.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-gradient-to-r from-cyan-500 via-purple-600 to-pink-500 text-white font-bold text-lg rounded-lg shadow-[0_0_30px_rgba(168,85,247,0.6)] hover:shadow-[0_0_50px_rgba(168,85,247,0.9)] transition-all duration-300"
            >
              Visit Website
            </a>
          </div>

          {/* Description */}
          <div className="max-w-4xl mx-auto text-left space-y-6">
            <p className="text-white/90 text-lg leading-relaxed">
              The Incinerator by Mandox is the core deflationary powerhouse integrated into the Mandox ecosystem's DEX — a high-velocity burn engine that systematically torches token supply to amplify scarcity and long-term value for $MANDOX holders.
            </p>

            <p className="text-white/90 text-lg leading-relaxed">
              This isn't just another gimmick: it's a revenue-fueled, protocol-embedded mechanism that permanently eliminates tokens from circulation. Powered by trading fees, utility activations, cross-chain activity, and community-driven burns, every swap feeds the blaze. The result? Relentless supply reduction that crushes dilution and rewards diamond-handed believers who stay in the fire.
            </p>

            <div className="space-y-4 pt-4">
              <p className="text-white font-semibold text-xl">Key features include:</p>
              <ul className="space-y-3 text-white/90 text-lg">
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">🔥</span>
                  <span><strong>Automated & On-Chain Burns</strong> — .25% of every transaction gets sent to dead address, reducing circulating supply in real time.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">🔥</span>
                  <span><strong>Ecosystem-Wide Deflation</strong> — Targets $MANDOX (Ethereum) for sustained, ecosystem-wide supply reduction.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">🔥</span>
                  <span><strong>Transparency & Impact</strong> — Every burn cycle is verifiable on-chain, visibly slashing supply and driving upward pressure.</span>
                </li>
              </ul>
            </div>

            <p className="text-white/90 text-lg leading-relaxed pt-4">
              In a world full of rugs and fading hype, the Incinerator DEX stands as the forge where weak hands melt away and strong ones emerge unbreakable. It's not optional — it's the mechanism turning Mandox into pure, scarcity-fueled momentum.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}
